import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface DynamicTrialsFiltersState {
  categories: {
    label: string;
    type: 'category' | 'sponsor' | 'location';
    value: string;
  }[];
  clearCategories: () => void;
  clearCategoriesList: (type: 'category' | 'sponsor' | 'location') => void;
  setCategories: (
    categoryId: string,
    categoryLabel: string,
    type: 'category' | 'sponsor' | 'location',
  ) => void;
  setCategoriesList: (
    categories: {
      label: string;
      value: string;
    }[],
    type: 'category' | 'sponsor' | 'location',
  ) => void;
}

export const useDynamicTrialsFiltersStore = create<DynamicTrialsFiltersState>()(
  persist(
    (set) => ({
      categories: [],
      setCategories: (
        categoryId: string,
        categoryLabel: string,
        type: 'category' | 'sponsor' | 'location',
      ) => {
        set(({ categories }) => {
          const category = categories.find((c) => c.value === categoryId);

          return {
            categories: category
              ? categories.filter((c) => c.value !== categoryId)
              : [...categories, { label: categoryLabel, value: categoryId, type }],
          };
        });
      },
      clearCategories: () => {
        set(() => ({ categories: [] }));
      },
      setCategoriesList: (
        categories: {
          label: string;
          value: string;
        }[],
        type: 'category' | 'sponsor' | 'location',
      ) => {
        set(({ categories: existingCategories }) => ({
          categories: [
            ...existingCategories,
            ...categories
              .filter(
                (c) => !existingCategories.some((ex) => ex.value === c.value && ex.type === type),
              )
              .map((c) => ({ ...c, type })),
          ],
        }));
      },
      clearCategoriesList: (type: 'category' | 'sponsor' | 'location') => {
        set(({ categories: existingCategories }) => ({
          categories: existingCategories.filter((existing) => existing.type !== type),
        }));
      },
    }),
    {
      name: 'dynamic-trials-filters',
    },
  ),
);

export const clearDynamicTrialsFiltersStore = () =>
  useDynamicTrialsFiltersStore.persist.clearStorage();
